import { OptionalEnumSchema } from 'notable-common';
import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FLOW_REST_METHOD_AND_ENDPOINT_HELPER_TEXT } from '../rest/config.js';
import { FlowRestRequestBodyFormat } from '../rest/shared/bodyFormat.js';
import { FlowBlockType } from '../type.js';
/**
 * Structural validation only. flow-api layers on a check that each secure header's domain matches
 * the endpoint, which needs the database and so cannot live here.
 */
export const FlowRestApiClassicAuthorizationBlockConfigSchema = z.object({
    endpoint: z.string().min(4, {
        message: `Required - ${FLOW_REST_METHOD_AND_ENDPOINT_HELPER_TEXT}`,
    }),
    apiInstanceId: z.string(),
    secureHeaders: z
        .array(z.object({
        id: z.uuid(),
    }))
        .optional(),
    selectedResponseHeaders: z.array(z.string()).optional(),
    method: z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']),
    headers: z
        .array(z.object({
        key: z.string().min(1, {
            message: 'Header key cannot be empty.',
        }),
        value: z.string().min(1, {
            message: 'Header value cannot be empty.',
        }),
    }))
        .optional(),
    bodyFormat: OptionalEnumSchema(FlowRestRequestBodyFormat, FlowRestRequestBodyFormat.RawJson),
    params: z.string().optional(),
    body: z.string().optional(),
});
export const FlowRestApiClassicAuthorizationBlockBaseSchema = z.object({
    type: z.literal(FlowBlockType.RestApiClassicAuthorization),
    config: FlowRestApiClassicAuthorizationBlockConfigSchema,
});
export const FlowRestApiClassicAuthorizationBlockSchema = BaseFlowBlockSchema.extend(FlowRestApiClassicAuthorizationBlockBaseSchema.shape);
//# sourceMappingURL=config.js.map